module.exports = {
	"header": "Next career step up north",
	"date": "2022/01/03",
	"imgSrc": "Waqar_Spotin_news.jpg",
	"imgAlt": "Waqar Ali Subhani",
	"ingress": "Luleå-based Spotin, developing solutions for connecting digital content and e-commerce, sees great potential in global recruitments where cultural influences lead to greater innovation.",
	"sections": [
		{
			"paragraphs": [
				"The latest recruitment, Waqar Ali Subhani, leaves Thailand and his job at the Thai giant CP group for the tech company in Luleå.",
				"Sandy beaches turned to ice roads when computer engineer Waqar Ali Subhani chose a new career in Luleå and Sweden. Waqar has 10 years of experience in both back- and front-end development and most recently comes from Thailand's largest corporate conglomerate, the Charoen Pokphand group. With his long experience, he enters a role as a senior front-end developer at Spotin. The focus will partly be on Spotin's architecture and software development in line with upscaling of the company.",
				"Just like in Sweden, the startup scene in Thailand is growing at a rapid pace, while Waqar also sees differences between the Swedish and Thai companies. He describes the work culture as warmer and more open-minded in Luleå, which allows the individual and the company greater opportunities."
			],
			"quote": {
				"text": "“The biggest difference between the Swedish company and the work culture in Thailand lies in the organizational structure. I see the team spirit and the direct democratic, flatter organization as a key to productivity. Especially in a small company where everyone's opinions count. I see Spotin's business concept as a winning concept, we need a modern e-commerce market that is not dependent on additional players to function.”",
				"author": "Waqar Ali Subhani",
				"title": "Sr. Frontend developer, Spotin"
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/1/article.json
// module id = 7
// module chunks = 0